import { ChannelProvider } from "@pandas/realtime";
import { createFileRoute } from "@tanstack/react-router";
import RevealImei from "@/features/tradein/pages/reveal-imei/RevealImei";
import { useStore } from "@/store";

function RevealImeiRoute() {
	const sessionId = useStore((state) => state.sessionId);
	return (
		<ChannelProvider channelName={sessionId}>
			<RevealImei />
		</ChannelProvider>
	);
}

export const Route = createFileRoute("/$locale/$partner/_device/reveal-imei")({
	component: RevealImeiRoute,
});
